<div class="container py-5 login-page-container">
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6 col-xl-5">

      <div class="text-center mb-4 mt-6 pt-5">
        <h1 class="mat-display-1 fw-bold" style="color: #215DAB">Welcome Back</h1>
        <p class="mat-subheading-2 text-secondary">Sign in to your account</p>
      </div>

      <mat-card class="p-4 shadow-lg rounded" style="background-color: #f8faff;">
        <mat-card-content>
          <mat-progress-spinner class="mx-auto my-3" *ngIf="showProgressSpinner" mode="indeterminate" diameter="40">
          </mat-progress-spinner>

          <app-success-message [message]="this.successMessage"></app-success-message>
          <app-error-message [message]="this.errorMessage"></app-error-message>

          <form (ngSubmit)="onSubmit(f)" #f="ngForm" class="form">
            <div class="mb-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Username</mat-label>
                <input
                  type="text"
                  name="name"
                  required
                  matInput
                  ngModel>
                <mat-icon matPrefix class="text-secondary me-2">person</mat-icon>
                <mat-error *ngIf="f.controls['name']?.invalid && f.controls['name']?.touched">
                  Username is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="mb-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Password</mat-label>
                <input
                  type="password"
                  name="pass"
                  required
                  matInput
                  ngModel>
                <mat-icon matPrefix class="text-secondary me-2">lock</mat-icon>
                <mat-error *ngIf="f.controls['pass']?.invalid && f.controls['pass']?.touched">
                  Password is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="d-grid gap-2">
              <button
                [disabled]="!f.valid"
                type="submit"
                mat-raised-button
                color="primary"
                class="py-2">
                <span class="d-flex align-items-center justify-content-center">
                  <mat-icon class="me-2">login</mat-icon>
                  <span>Sign In</span>
                </span>
              </button>
            </div>

            <div class="mt-3 text-center">
              <a mat-button routerLink="/auth/forgot-password" color="accent">Forgot Password?</a>
            </div>
          </form>
        </mat-card-content>
      </mat-card>

      <!-- <div class="text-center mt-4">
        <p class="text-muted mb-0">Don't have an account? <a mat-button style="color: #215DAB" routerLink="/auth/register">Sign Up</a></p>
      </div> -->
    </div>
  </div>
</div>
